import moment from 'moment/moment';

export function parseDate(date: Date) {
  const currentDate = new Date(date);
  return moment(currentDate).format('MMM, DD, YYYY, hh:mm a');
}
